import { useTranslation } from 'next-i18next';
import type { Market } from '@bridebook/toolbox/src/gazetteer';
import { ISupplierPackage } from '@bridebook/toolbox/src/map-packages-to-sections';
import { Box } from '@bridebook/ui';
import PackagePricingBox from '@bridebook/web/app-shared/components/supplier/sections/pricing/package-pricing-box';
import componentStyles from './photographer-pricing.style';

interface IProps {
  currency?: string | null;
  description?: string;
  market: Market;
  maxPrice?: number;
  minPrice?: number;
  onShowMore?: () => void;
  packages?: ISupplierPackage[];
}

const PackagePricing = ({
  currency,
  description,
  market,
  maxPrice,
  minPrice,
  onShowMore,
  packages,
}: IProps) => {
  const { t } = useTranslation('supplier');

  if (!packages || !currency) return null;

  const formatPrice = (price: number) =>
    market.formatCurrency(price, {
      currency,
      maximumFractionDigits: 0,
    });

  const priceString = () => {
    if (minPrice && maxPrice) return `${formatPrice(minPrice)} - ${formatPrice(maxPrice)}`;
    if (minPrice && !maxPrice) return `${t('supplier.packages.from')} ${formatPrice(minPrice)}`;
    return '';
  };

  const styles = componentStyles();

  return (
    <Box pb={8}>
      <Box style={styles.price}>{priceString()}</Box>
      {description && <Box style={styles.description}>{description}</Box>}
      <Box gap={3}>
        {packages?.map((supplierPackage) => (
          <PackagePricingBox
            market={market}
            key={supplierPackage.id}
            supplierPackage={supplierPackage}
            currency={currency}
            onShowMore={onShowMore}
          />
        ))}
      </Box>
    </Box>
  );
};

export default PackagePricing;
